<div class="manage-booking-dialog-container">
    <div class="dialog-header">
        <h3 class="dialog-title">{{ 'PARKIFLY.HOME.MANAGE_BOOKING' | transloco }}</h3>
        <button mat-icon-button class="dialog-close-btn" (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body" [formGroup]="handleBookingGroup" *ngIf="handleBookingGroup">
        <mat-form-field appearance="outline" class="dialog-form-field">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email">
        </mat-form-field>

        <mat-form-field appearance="outline" class="dialog-form-field">
            <mat-label>{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}</mat-label>
            <input matInput placeholder="{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}"
                formControlName="bookingNumber">
        </mat-form-field>

        <button mat-raised-button color="primary" class="dialog-search-button" (click)="goToHandleBookingForm()">
            {{ 'PARKIFLY.MANAGE_BOOKING.SEARCH' | transloco }}
        </button>

        <p class="dialog-footer-text">
            {{'LOGIN.ORDERS' | transloco}} <a (click)="openLoginDialog()">{{ 'DRIVE_IN_BOOKING.INFO_MSG' |
                transloco }}</a>
        </p>
    </div>
</div>